module.exports = __webpack_public_path__ + "media/images/vp/icon.addfriend.white-bf95d2c84943995b8b9af7b80f856481.svg";